import { Information } from 'assets/icons';
import Button from 'components/button';
import ModalBody from 'components/modal/components/body';
import ModalFooter from 'components/modal/components/footer';
import Modalheader from 'components/modal/components/header';
import useModal from 'components/modal/useModal';
import StyledInput from 'components/styledInput/StyledInput';
import UseContext from 'hooks/useContext';
import { useEffect, useState } from 'react';

const Temporaire = () => {
  const { dataCreateMission, setDataCreateMission, language } = UseContext();
  const text = (key, fallback) =>
    language.getValue(`missionCreation.motifForm.${key}`, fallback);
  const [validMotif, setValidMotif] = useState(false);
  const [message, setMessage] = useState(() => {
    if (dataCreateMission?.motif?.type === '4') {
      return { type: '4', message: dataCreateMission.motif.message || '' };
    }
    return { type: '4', message: '' };
  });
  const [lengthMessage, setLengthMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [validMessage, setValidMessage] = useState(false);
  const { toggle } = useModal();
  const verif = message.message.length;

  useEffect(() => {
    if (verif <= 8) {
      setErrorMessage(true);
      setLengthMessage(false);
    } else {
      setErrorMessage(false);
      setLengthMessage(true);
    }
    setValidMotif(message.message.length > 0);
  }, [message, verif]);

  const handleMessage = (e) => {
    setMessage((prev) => ({ ...prev, message: e.target.value }));
  };

  const handleSubmit = () => {
    if (lengthMessage) {
      setDataCreateMission((prevData) => ({
        ...prevData,
        motif: message,
      }));
      toggle();
    }
  };

  return (
    <>
      <Modalheader hide={toggle} hideShow={true}>
        {text('titles.customaryContract', 'Contrat temporaire d’usage')}
      </Modalheader>
      <ModalBody>
        <form className="flex flex-col w-full gap-4 mt-4">
          <StyledInput
            type={'textarea'}
            label={text('description', 'Votre description')}
            value={message.message}
            maxLength={250}
            hint={text('maxLengthHint', '250 caractères')}
            onChange={handleMessage}
          />
          {errorMessage && (
            <p className="text-yellow-400 flex items-center gap-4">
              <Information wh={16} color={'#FFA43D'} />
              {text(
                'lengthError',
                'Veuillez faire un message de plus de 10 caractères',
              )}
            </p>
          )}
        </form>
      </ModalBody>
      <ModalFooter>
        <Button size={'LG'} color={'SECONDARY'} onClick={toggle}>
          {text('cancel', 'Annuler')}
        </Button>
        <Button size={'LG'} onClick={handleSubmit} disabled={!lengthMessage}>
          {text('confirm', 'Confirmer')}
        </Button>
      </ModalFooter>
    </>
  );
};

export default Temporaire;
